import { Box, CircularProgress } from '@mui/material';

// Inline loading state for a single dashboard section fetch - lighter than
// AppStatus, which assumes it owns the whole page (auth checks, public
// profile loads) rather than sitting inside the already-rendered dashboard
// chrome.
function SectionLoading() {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', py: 10 }}>
      <CircularProgress />
    </Box>
  );
}

export default SectionLoading;
